var company = {};
module['exports'] = company;
company.suffix = require("./suffix");
company.name = require("./name");
